import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ButtonPrimary} from '@homeaway/react-buttons';
import Modal from '@homeaway/react-modal';
import {AlertSuccess, AlertDanger} from '@homeaway/react-alerts';
import {SVGIcon} from '@homeaway/react-svg';
import {HOUSE__16, SUITCASE__16, STAR__16, CHAT__16} from '@homeaway/svg-defs';
import {FormInput, Checkbox} from '@homeaway/react-form-components';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import PropTypes from 'prop-types';

import './styles.less';

function mapStateToProps(state) {
    return {
        loginPath: state.app.loginLink && state.app.loginLink.path,
    };
}

export class LandingPage extends Component {
    constructor(props) {
        super(props);
        let {isLoggedIn, appLinks} = props;
        let hasAppAccess =
            appLinks instanceof Array
                ? appLinks.find((nav) => nav.enabled)
                : false;
        this.state = {
            modalIsOpen: isLoggedIn && !hasAppAccess,
            companyName: '',
            companyNameErrorMsg: '',
            accepted: false,
            benefits: [
                {
                    icon: HOUSE__16,
                    header: 'landing.listing.header',
                    description: 'landing.listing.description',
                },
                {
                    icon: SUITCASE__16,
                    header: 'landing.onlineBooking.header',
                    description: 'landing.onlineBooking.description',
                },
                {
                    icon: STAR__16,
                    header: 'landing.reviews.header',
                    description: 'landing.reviews.description',
                },
                {
                    icon: CHAT__16,
                    header: 'landing.inquiry.header',
                    description: 'landing.inquiry.description',
                },
            ],
            faq: [
                {
                    question: 'landing.faq.question1',
                    answer: (translations) => {
                        return (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: translations['landing.faq.answer1'],
                                }}
                            />
                        );
                    },
                },
                {
                    question: 'landing.faq.question2',
                    answer: (translations) => {
                        return (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: translations['landing.faq.answer2'],
                                }}
                            />
                        );
                    },
                },
                {
                    question: 'landing.faq.question3',
                    answer: (translations) => {
                        return (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: translations['landing.faq.answer3'],
                                }}
                            />
                        );
                    },
                },
                {
                    question: 'landing.faq.question4',
                    answer: (translations) => {
                        return (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: translations['landing.faq.answer4'],
                                }}
                            />
                        );
                    },
                },
            ],
        };

        this.handleRequestAccess = this.handleRequestAccess.bind(this);
        this.handleSubmitRequestAccess =
            this.handleSubmitRequestAccess.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.companyNameChange = this.companyNameChange.bind(this);
        this.handleTermAcceptance = this.handleTermAcceptance.bind(this);
    }

    companyNameChange(event) {
        this.setState({
            companyName: event.target.value,
        });
    }

    handleRequestAccess(position) {
        return (event) => {
            if (event) {
                event.preventDefault();
            }

            if (position === 'Primary') {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction:
                            'Request Access Primary Button Click (User logged in)',
                    },
                    {}
                );
            } else if (position === 'Secondary') {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction:
                            'Request Access Secondary Button Click (User logged in)',
                    },
                    {}
                );
            } else {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction: 'Request Access FAQ link (User logged in)',
                    },
                    {}
                );
            }

            this.setState({
                modalIsOpen: true,
            });
        };
    }

    redirectToHref(href) {
        window.location.href = href;
    }

    handleRequestAccessUnauthenticated(href, position) {
        return (event) => {
            if (event) {
                event.preventDefault();
            }

            if (position === 'Primary') {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction:
                            'Request Access Primary Button Click (User not logged in)',
                    },
                    {}
                );
            } else if (position === 'Secondary') {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction:
                            'Request Access Secondary Button Click (User not logged in)',
                    },
                    {}
                );
            } else {
                this.props.actions.triggerEdapEvent(
                    'generic.event',
                    {
                        eventcategory: 'Request Access',
                        eventaction:
                            'Request Access FAQ link (User not logged in)',
                    },
                    {}
                );
            }

            this.redirectToHref(href);
        };
    }

    handleTermAcceptance() {
        this.setState({
            accepted: !this.state.accepted,
        });
    }

    handleSubmitRequestAccess() {
        if (this.state.companyName === '') {
            this.setState({
                companyNameErrorMsg: 'landing.empty.companyName',
            });
            return;
        }

        this.props.actions.triggerEdapEvent(
            'generic.event',
            {
                eventcategory: 'Request Access',
                eventaction: 'Request Access Modal Button',
            },
            {}
        );

        this.setState({
            companyNameErrorMsg: '',
        });
        this.props.actions.enableLoadOverlay(true);
        this.props.actions.submitRequestAccess(this.state.companyName);
    }

    onModalClose() {
        this.setState({
            modalIsOpen: false,
            accepted: false,
            companyNameErrorMsg: null,
        });
    }

    generateFaq(faqList, translations, isLoggedIn) {
        return (
            <div className="row bottom-spacing">
                <div className="col-md-6">
                    <h3>{translations[faqList[0].question]}</h3>
                    {faqList[0].answer(translations, isLoggedIn)}
                </div>
                <div className="col-md-6">
                    <h3>{translations[faqList[1].question]}</h3>
                    {faqList[1].answer(translations)}
                </div>
            </div>
        );
    }

    generateRequestAccessButton(isLoggedIn, position) {
        if (isLoggedIn) {
            return (
                <ButtonPrimary
                    onClick={this.handleRequestAccess(position)}
                    label="Request Access"
                />
            );
        }
        const {loginPath} = this.props;
        return (
            <ButtonPrimary
                href={loginPath}
                onClick={this.handleRequestAccessUnauthenticated(
                    loginPath,
                    position
                )}
                label="Request Access"
            />
        );
    }

    render() {
        let {
            loading,
            isLoggedIn,
            requestSubmitted,
            requestAccessError,
            translations,
            heroExport,
            metrics,
            documentation,
            testingTools,
        } = this.props;

        return (
            <div className="landing-page-container">
                <Modal
                    id="pmscSignUp"
                    isOpen={this.state.modalIsOpen}
                    onClose={this.onModalClose}
                    title={translations['landing.modal.header']}
                >
                    {!requestSubmitted ? (
                        <div>
                            {loading && <LoadingOverlay />}
                            {requestAccessError && (
                                <AlertDanger
                                    msg={translations[requestAccessError]}
                                    dismissible
                                />
                            )}
                            <p>{translations['landing.modal.description']}</p>
                            <FormInput
                                id="company-name"
                                label={
                                    translations[
                                        'landing.modal.companyName.input'
                                    ]
                                }
                                onChange={this.companyNameChange}
                                value={this.state.companyName}
                                errorMsg={
                                    translations[this.state.companyNameErrorMsg]
                                }
                            />
                            <div className="panel panel-default">
                                <div className="panel-heading input-padding">
                                    {
                                        translations[
                                            'landing.terms.and.conditions.header'
                                        ]
                                    }
                                </div>
                                <div
                                    className="panel-body"
                                    style={{
                                        maxHeight: '250px',
                                        overflow: 'scroll',
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: translations[
                                            'landing.terms.and.conditions'
                                        ],
                                    }}
                                />
                            </div>
                            <Checkbox
                                label={
                                    translations[
                                        'landing.acknowledge.and.accept'
                                    ]
                                }
                                checked={this.state.accepted}
                                onChange={this.handleTermAcceptance}
                                size="sm"
                            />
                            <div className="text-right">
                                <ButtonPrimary
                                    onClick={this.handleSubmitRequestAccess}
                                    label={
                                        translations['landing.request.access']
                                    }
                                    disabled={!this.state.accepted}
                                />
                            </div>
                        </div>
                    ) : (
                        <AlertSuccess>
                            <h4>
                                {
                                    translations[
                                        'landing.received.request.header'
                                    ]
                                }
                            </h4>
                            <p>
                                {
                                    translations[
                                        'landing.received.request.description'
                                    ]
                                }
                                <strong>{this.state.companyName}</strong>
                                {'.'}
                            </p>
                        </AlertSuccess>
                    )}
                </Modal>

                <div className="container page-graphic-container">
                    <img className="hero-svg-container" src={heroExport()} />
                    <div
                        className="row max-width-content hero-main-text"
                        style={{padding: '12% 12% 0'}}
                    >
                        <div className="col-md-4">
                            <h1>{translations['landing.hero.main.text']}</h1>
                            {this.generateRequestAccessButton(
                                isLoggedIn,
                                'Primary'
                            )}
                        </div>
                        <div className="col-md-8" />
                    </div>
                    <div
                        className="row max-width-content"
                        style={{padding: '10% 12% 0'}}
                    >
                        {this.state.benefits.map((entry) => {
                            return (
                                <div
                                    key={entry.header}
                                    className="col-md-3 col-sm-6"
                                >
                                    <h3>
                                        <span className="text-brand">
                                            <SVGIcon markup={entry.icon} />
                                        </span>
                                        {` ${translations[entry.header]}`}
                                    </h3>
                                    <p>{translations[entry.description]}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="text-center container tool-preview-container">
                    <div className="row bottom-spacing">
                        <div className="col-md-12">
                            <h2>
                                {translations['landing.featuresPreview.header']}
                            </h2>
                        </div>
                    </div>
                    <div className="row bottom-spacing">
                        <div className="col-sm-4 col-md-offset-2 col-md-3">
                            <img
                                className="benefit-svg bottom-spacing"
                                src={documentation()}
                            />
                            <h3>{translations['ic.docs']}</h3>
                        </div>
                        <div className="col-sm-4 col-md-2">
                            <img
                                className="benefit-svg bottom-spacing"
                                src={testingTools()}
                            />
                            <h3>{translations['ic.test.tools']}</h3>
                        </div>
                        <div className="col-sm-4 col-md-3">
                            <img
                                className="benefit-svg bottom-spacing"
                                src={metrics()}
                            />
                            <h3>{translations['ic.integration.metrics']}</h3>
                        </div>
                    </div>
                    <div className="row">
                        {this.generateRequestAccessButton(
                            isLoggedIn,
                            'Secondary'
                        )}
                    </div>
                </div>
                <div className="container faq-container max-width-content">
                    <div className="row text-center bottom-spacing">
                        <h2>{translations['landing.faq.header']}</h2>
                    </div>
                    {this.generateFaq(
                        this.state.faq.slice(0, 2),
                        translations,
                        isLoggedIn
                    )}
                    {this.generateFaq(
                        this.state.faq.slice(2, 4),
                        translations,
                        isLoggedIn
                    )}
                </div>
            </div>
        );
    }
}

LandingPage.propTypes = {
    isLoggedIn: PropTypes.any,
    appLinks: PropTypes.arrayOf(PropTypes.object),
    loginPath: PropTypes.string,
    translations: PropTypes.object,
    actions: PropTypes.object,
    loading: PropTypes.any,
    requestSubmitted: PropTypes.bool,
    requestAccessError: PropTypes.bool,
    heroExport: PropTypes.any,
    metrics: PropTypes.any,
    documentation: PropTypes.any,
    testingTools: PropTypes.any,
};

export default connect(mapStateToProps)(LandingPage);
